import { render, staticRenderFns } from "./ProgramMedia.vue?vue&type=template&id=461172ce&scoped=true&"
import script from "./ProgramMedia.vue?vue&type=script&lang=ts&"
export * from "./ProgramMedia.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramMedia.vue?vue&type=style&index=0&id=461172ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461172ce",
  null
  
)

export default component.exports